
import * as React from "react"
import { cn } from "@/lib/utils"
import { useSidebar } from "./sidebar-provider"

const SidebarGroup = ({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cn("py-2", className)} {...props}>
      {children}
    </div>
  )
}
SidebarGroup.displayName = "SidebarGroup"

const SidebarGroupLabel = ({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const { isCollapsed } = useSidebar();
  
  if (isCollapsed) return null;
  
  return (
    <div
      className={cn("px-3 py-2 text-xs font-semibold text-muted-foreground", className)}
      {...props}
    >
      {children}
    </div>
  )
}
SidebarGroupLabel.displayName = "SidebarGroupLabel"

const SidebarGroupContent = ({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cn("space-y-1", className)} {...props}>
      {children}
    </div>
  )
}
SidebarGroupContent.displayName = "SidebarGroupContent"

export { SidebarGroup, SidebarGroupLabel, SidebarGroupContent }
